export default __webpack_public_path__ + "static/media/SLA.dcf5a1bf.jpg";